import { t } from "../components/locales";
export const METERS_TO_INCHES = 39.3701;
export const INCHES_TO_METERS = 0.0254;
export const METERS_TO_FEET = 3.28084;
// Удобные константы для шагов — использовать в controls на клиенте
export const FOOT = 0.3048;
export const HALF_FOOT = 0.1524;
export const INCH = 0.0254;
export const HALF_INCH = 0.0127;
// Единственная точка изменения значения
export function stepControl(control, direction) {
    const next = parseFloat((control.value + direction * control.step).toFixed(6));
    return clampValue(next, control);
}
export function clampValue(value, control) {
    let v = value;
    if (control.min !== undefined)
        v = Math.max(control.min, v);
    if (control.max !== undefined)
        v = Math.min(control.max, v);
    return v;
}
// Только для отображения — метры → строка
export function formatLength(meters, units, lang = 'en') {
    const value = Number(meters);
    if (!value || isNaN(value))
        return units === 'ft' ? '0"' : '0 m';
    if (units === 'm') {
        if (value < 1)
            return `${Math.round(value * 1000)} ${t(lang, 'units.mm')}`;
        return `${value.toFixed(3)} ${t(lang, 'units.m')}`;
    }
    const totalInches = value * METERS_TO_INCHES;
    const snapped = Math.round(totalInches * 16) / 16;
    let feet = Math.floor(snapped / 12);
    let remaining = snapped % 12;
    let whole = Math.floor(remaining);
    const frac = remaining - whole;
    const sixteenths = Math.round(frac * 16);
    let fracStr = '';
    if (sixteenths === 16) {
        whole += 1;
    }
    else if (sixteenths > 0) {
        const gcd = (a, b) => b ? gcd(b, a % b) : a;
        const g = gcd(sixteenths, 16);
        fracStr = ` ${sixteenths / g}/${16 / g}`;
    }
    if (whole === 12) {
        whole = 0;
        feet += 1;
    }
    if (feet === 0)
        return `${whole}${fracStr}"`;
    if (whole === 0 && !fracStr)
        return `${feet}'`;
    return `${feet}' ${whole}${fracStr}"`;
}
export const formatFraction = (decimal) => {
    const sixteenths = Math.round(decimal * 16);
    if (sixteenths === 0)
        return '';
    if (sixteenths === 16)
        return '1';
    const gcd = (a, b) => (b ? gcd(b, a % b) : a);
    const common = gcd(sixteenths, 16);
    return `${sixteenths / common}/${16 / common}`;
};
// Угол в градусах → pitch X:12
export function degreesToPitch(deg) {
    const rise = Math.round(Math.tan(deg * Math.PI / 180) * 12 * 4) / 4;
    return `${rise}:12`;
}
